import React from 'react';
export function Footer() {
  return <footer className="py-12 md:py-16 border-t border-neutral-900" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-18">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-neutral-900 border border-[#D4AF37]/30 text-[#D4AF37] text-sm font-bold tracking-wider mb-6" data-id="element-19">
          KIT MÁQUINA DE VENTAS™
        </div>

        <p className="text-gray-300 font-medium text-base md:text-lg mb-2" data-id="element-20">
          El protocolo N°1 para emprendedores digitales en Argentina.
        </p>
        <p className="text-gray-500 text-sm md:text-base mb-10" data-id="element-21">
          Porque construir un negocio digital no debería costarte años de cursos
          sin resultados.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-gray-400 mb-10" data-id="element-22">
          <a href="mailto:soportenexorecursos@gmail.com" className="hover:text-[#D4AF37] transition-colors" data-id="element-23">
            📧 soportenexorecursos@gmail.com
          </a>
          <span className="hidden md:inline text-gray-800" data-id="element-24">|</span>
          <a href="https://ventas.nexorecursos.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors" data-id="element-25">
            🌐 ventas.nexorecursos.com
          </a>
        </div>

        <div className="text-gray-600 text-xs md:text-sm space-y-1 mb-12" data-id="element-26">
          <p data-id="element-27">
            © Kit Máquina de Ventas™ 2025 — Todos los derechos reservados.
          </p>
          <p data-id="element-28">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="pt-8 border-t border-neutral-900" data-id="element-29">
          <p className="text-gray-500 italic font-medium text-sm md:text-base" data-id="element-30">
            "Tu primer ingreso digital es posible. El sistema está acá. Solo
            falta que lo enciendas."
          </p>
        </div>
      </div>
    </footer>;
}